module.exports = __webpack_public_path__ + "static/2front-about-people-2-8462f33bc5af498b864ba9b389ce12c5.png";